<template>
    <list-page title="节假日管理" :api="searchUrl" :searchParam="searchParam" :showPager="false" ref="page">
        <template v-slot:search>
            <div class="block">
                <el-select size="mini" v-model="searchParam.Key" @change="onDateChanged">
                    <el-option v-for="item in yearList" :key="item" :label="item + ' 年'" :value="item"> </el-option>
                </el-select>
            </div>
        </template>
        <template v-slot:other>
            <AddHoliday @close="showEdit = false" v-if="showEdit" :show="showEdit" @save="saveHoliday"> </AddHoliday>
        </template>
        <template v-slot:new>
            <el-button type="primary" size="mini" icon="el-icon-plus" @click="showEdit = true"> 新增 </el-button>
        </template>
        <el-table-column label="序号" width="80px">
            <template #default="scope">
                {{ scope.$index + 1 }}
            </template>
        </el-table-column>
        <el-table-column label="名称" property="Name"> </el-table-column>
        <el-table-column label="开始日期" property="BeginDate" :formatter="formatDate"> </el-table-column>
        <el-table-column label="结束日期" property="EndDate" :formatter="formatDate"> </el-table-column>
        <el-table-column label="操作" width="120px">
            <template #default="scope">
                <el-button type="danger" plain @click="removeObject(scope.row)" size="mini" icon="el-icon-delete"> 删除 </el-button>
            </template>
        </el-table-column>
    </list-page>
</template>
<script>
import AddHoliday from "./components/AddHoliday.vue";
export default {
    name: "Holiday",
    components: { AddHoliday },
    data() {
        return {
            dataList: [],
            yearList: [],
            showEdit: false,
            searchUrl: "/Platform/GetHolidays",
            searchParam: {
                Key: 2000,
            },
        };
    },
    created() {
        let date = new Date();
        this.searchParam.Key = date.getFullYear();
        let maxYear = date.getFullYear() + 1;
        let arr = [];
        for (let i = 2000; i <= maxYear; i++) {
            arr.push(i);
        }
        this.yearList = arr;
    },
    methods: {
        onDateChanged() {
            this.$refs.page.searchData();
        },
        removeObject(item) {
            if (confirm("确定要删除吗")) {
                this.$ajax.post("/Platform/RemoveHolidays", item).then((result) => {
                    this.onDateChanged();
                });
            }
        },
        formatDate(row, column, cellValue, index) {
            if (cellValue) {
                let date = new Date(cellValue);
                return date.format("yyyy-MM-dd");
            }
            return "";
        },
        saveHoliday(data) {
            this.$ajax.post("/Platform/AddHolidays", data).then((result) => {
                this.showEdit = false;
                this.onDateChanged();
            });
        },
    },
};
</script>
